
import React from "react";
import { connect } from "react-redux";
import Tooltip from "@/src/components/common/Elements/Tooltip/Tooltip";

import Axios from "Source/axiosPool";
import Select from "Components/common/Select/Select";

@connect(store => {
    return {
        conversations: store.conversations,
        loggedUser: store.loggedUser
    };
})
class Links extends React.Component {
    constructor(props) {
        super(props);
        this.state={
            members:[],
            workstreams:[],
            openTag:false,
            selectedWorkstream:[],
            selectedMembers:[],
            subject:null

        }
        _.map(
            ["fetchWorkstreams"],
            fn => {
                this[fn] = this[fn].bind(this);
            }
        );
    }

    fetchWorkstreams(options = null){
        const { projectId, loggedUser } = this.props;
        let fetchUrl = `/api/workstream`;
        const params={
            projectId:projectId,
            page:1,
            userId:loggedUser.data.id,
            userRole:loggedUser.data.userRole,
            workstreamStatus:'Active',
            section: 'conversation',
            ...(options ? { workstream: options } : {})
        }

        Axios.get(fetchUrl, params).then(c => {
            if(c) {
                const workstreamOptions = _(c.data.result)
                    .map(e => {
                        return { value: e.id, label: e.workstream, color: e.color};
                    }).value();

                this.setState({ ...this.state, workstreams: workstreamOptions });
            }
        });
         
    }

    render() {
        const { dispatch, conversations } = this.props;

        const handleSelectworkstreams = (value, action)=>{
            if(action === "all") {
                dispatch({ type: "UPDATE_CONVERSATIONS_FIELD", field: "workstreams", value });
            } else {
                dispatch({ type: "UPDATE_CONVERSATIONS_FIELD", field: "workstreams", value: action !== "removed" ? [...conversations.fields.workstreams, value] : conversations.fields.workstreams.filter( c => c.value !== value.value ) });
            };
        }
        
        const handleRenderOptionWorkstream = value =>{
            return (
                <div class="taggedWorkstreamDetails">
                     <div class="workstreamStatusIndicator" style={{background: `${value.color}`}}></div>
                    <div class="taggedWorkstreamContent">
                        <p>{value.label}</p>
                    </div>
                </div>
            );
        }

        const handleOpenTag = () => {
            this.fetchWorkstreams();

            this.setState({ ...this.state, openTag: true });
        }
        
        return (
            <div class="formContainer workstreamConvoContainer">
                <label>Links:</label>
                <a class='note_workstream_tag'   data-tooltip-id={`links-workstream-tag`} onClick={ handleOpenTag }>
                    <i class="material-icons text-size22">sell</i>

                    <Tooltip id={`links-workstream-tag`}  place="bottom" effect="solid" >
                        Tag to a workstream
                    </Tooltip>
                </a>
                <Select 
                    includeSelectAll={true}
                    selectAllLabel={'All workstream'}
                    isMultiple={true}
                    isSearchable={true}
                    classes={{options: `recipientOptions workstreamConvoOptions`}}
                    options={this.state.workstreams}
                    placeholder="Search"
                    onChange={handleSelectworkstreams}
                    iconOnly={true}
                    anchorEl={$('.note_workstream_tag')}
                    renderOption={handleRenderOptionWorkstream}
                    isOpen={this.state.openTag}
                    onBlur={()=>{this.setState({ ...this.state, openTag:false })}}
                    searchIcon={<i class="material-icons">search</i>}
                    selected={ conversations.fields.workstreams }
                    isClose={ conversations.actionType === "formSubmit" }
                />

                {conversations.fields.workstreams.length > 0 && conversations.fields.workstreams.filter((v,i)=>i<3).map(value=>{
                    return (
                        <div class="taggedWorkstreamDetails">
                            <div class="workstreamStatusIndicator" style={{ background: `${value.color}` }}></div>
                            <div class="taggedWorkstreamContent">
                                <p>{value.label.length>24?value.label.substring(0,24)+"...":value.label}</p>
                            </div>
                        </div>
                    )
                })}

                {conversations.fields.workstreams.length > 3 &&
                    <React.Fragment>
                        <span   data-tooltip-id={`tooltip_selected_notes_workstream`}>+{conversations.fields.workstreams.length - 3} </span>
                        <Tooltip id={`tooltip_selected_notes_workstream`}  place="bottom" effect="solid" >
                            {conversations.fields.workstreams.filter((f,i)=>i >= 3).map(s=>
                                {
                                    return(
                                        <div>{s.label}</div>
                                    )
                                }
                            )}
                        </Tooltip>
                    </React.Fragment>
                }
            </div>
        );
    }
}

export default Links;